    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>
